import { Flex, Typography } from "@aircall/tractor";
import styled from "@xstyled/styled-components";

export const Wrapper = styled(Flex).attrs({
  alignItems: "center",
  flexWrap: "wrap",
})`
  row-gap: 0;
  column-gap: xs;
`;

export const Agent = styled(Typography).attrs({
  variant: "headingBoldS",
  color: "text-interactive-primary",
  ellipsis: true,
})``;

export const Client = styled(Typography).attrs({
  variant: "headingBoldS",
  color: "informative-500",
  ellipsis: true,
})``;

export const Text = styled(Typography).attrs({
  variant: "headingLightS",
  ellipsis: true,
  color: "text-base",
})``;

export const SpeakerName = styled(Typography).attrs({
  variant: "headingBoldS",
})``;
